export default __webpack_public_path__ + "static/media/how-it-works_05.f44c6003.png";